import {GetRandomNum} from "@/pages/base/utils";
import {OVERDUEDATE} from "@/pages/base/consts";
$(function(){

});